import axios from 'axios'
import qs from 'qs'
import store from '../store'
// const apiUrl = 'http://192.168.0.103:3000' // 开发
// const apiUrl = 'https://sentosa-miniapp.fooyotravel.com' // 圣淘沙正式
const apiUrl = 'https://sg-sentosa.fooyotravel.com'
// const apiUrl = 'https://sentosa-mini-staging.fooyotravel.com' // 圣淘沙测试
// const apiUrl = 'https://singapore.fooyotravel.com' // 新加坡正式
// const apiUrl = 'https://singapore-staging.fooyotravel.com' // 新加坡测试
// 获取客户端信息ID
function getClientId () {
  let id = localStorage.getItem('clientId')
  if (!id) {
    const randomStr = Math.round(Math.random() * 1000000)
    const timestamp = (new Date()).getTime()
    id = `Wechat_Mini_${timestamp}${randomStr}`
    localStorage.setItem('clientId', id)
  }
  return id
}

export function getWebUserId () {
  let id = localStorage.getItem('webUserId')
  if (!id) {
    const randomStr = Math.round(Math.random() * 1000000)
    const timestamp = (new Date()).getTime()
    id = `web_user_${timestamp}${randomStr}`
    localStorage.setItem('webUserId', id)
  }
  return id
}

// axios config that will be applied to every request
// axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://192.168.101.105:3000'
// axios.defaults.baseURL = 'https://sentosa-miniapp.fooyotravel.com' // interface address
axios.defaults.timeout = 120000
axios.defaults.headers.common = {
  'X-APP-KEY': 'Z1atkgygmbOTojjwQCQMYiWHhH4',
  'X-CLIENT-ID': getClientId()
}
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
axios.defaults.headers.delete['Content-Type'] = 'multipart/form-data'

// stringify post array
axios.interceptors.request.use((config) => {
  if (config.method === 'post') {
    config.headers['Content-Type'] = config.headers.post['Content-Type']
  }
  if (config.method === 'get') {
    // if(!config.data.locale) config.data['locale'] = 'en'
    // console.log(config.data.locale, 222222)
  }
  return config
}, (error) => {
  console.log('parameter is illegal') // need log function
  return Promise.reject(error)
})

axios.interceptors.response.use((res) => {
  if (res.status !== 200 && res.status !== 201 && res.status !== 204 && res.status !== 403) {
    return Promise.reject(res)
  }
  return Promise.resolve(res)
}, (error) => {
  console.log('失败信息')
  if (error && !error.request) {
    return Promise.reject(error)
  }
  return Promise.reject(error)
})

// @params
// e.g. headers = headers.post['Confirmation-Token'] = 'vx5WRKAzCCvZJQvT4zRy'
function fetch (url, params, method, headers, prefix = '/sg') {
  if ((method === 'get') && params) {
    url = url + '?' + qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return new Promise((resolve, reject) => {
    let defaultHeader = JSON.parse(JSON.stringify(axios.defaults.headers))
    if (store.state.siteId === '1') {
      defaultHeader['X-APP-ID'] = 'wx290df6d466c69c06'
    } else if (store.state.siteId === '129') {
      defaultHeader['X-APP-ID'] = 'wxd4228638d1783dfe'
    } else if (store.state.siteId === '33') {
      defaultHeader['X-APP-ID'] = 'wxf2e38b60b621cde9'
    } else if (store.state.siteId === '11') { // 其实是1因为和圣淘沙重复了所以写成了11
      defaultHeader['X-APP-ID'] = 'wx0abea9e1afe863fb'
    } else if (store.state.siteId === '206') {
      defaultHeader['X-APP-ID'] = 'wx06d3d0c57da34137'
    } else if (store.state.siteId === '438') {
      //乐和乐都DEMO
      defaultHeader['X-APP-ID'] = 'wxf290133d5364b604'
    } else {
      defaultHeader['X-APP-ID'] = 'wx35365eaf203a76fd'
    }

    let baseUrl = apiUrl

    if (headers) {
      Object.assign(defaultHeader, headers)
    }
    axios({
      url: `${baseUrl}${prefix}${url}`,
      data: params || {},
      method: method || 'get',
      headers: defaultHeader
    }).then((response) => {
      if (response.status === 200 || response.status === 204) {
        resolve(response.data)
      } else {
        reject(response.data)
      }
    }).catch((error) => {
      console.log('error======', error)
      reject(error)
    })
  })
}

// 请求地图导览poi数据
export function getPoiGroups (siteId, data) {
  return fetch(`/sites/${siteId}/poi_groups`, data, 'get')
}

// 获取推荐路线
export function getRoutes (siteId, params) {
  return fetch(`/sites/${siteId}/routes`, params, 'get')
}

// 获取历史搜索、热门搜索(新的)
export function getHotWords (headers, data) {
  return fetch('/search_words', data, 'get', headers)
}

// 提交历史搜索
export function postHistoryWord (q, headers) {
  return fetch('/search_words', { q }, 'post', headers)
}

// 删除历史搜索
export function deleteHistoryWords (headers) {
  return fetch('/search_words/batch_destroy', null, 'delete', headers)
}

// 提交搜索词
export function postSearch (siteId, searchStr) {
  return fetch(`/sites/${siteId}/hot_poi`, { key: searchStr }, 'post')
}

// 景点详情
export function getSubSiteDetail (id) {
  return fetch(`/sub_sites/${id}`)
}

// 搜索圣淘沙的place
export function searchPlace (siteId, data, headers) {
  return fetch(`/sites/${siteId}/places`, data, 'get', headers)
}

// 获取路线详情
export function getRouteDetail (params, headers) {
  return fetch('/nav_routes/routes', params, 'get', headers)
}

// 获取位置热门搜索
export function getHotPlace (siteId) {
  return fetch(`/sites/${siteId}/hot_places`)
}

// 提交位置搜索词
export function postPlaceSearch (siteId, searchStr) {
  return fetch(`/sites/${siteId}/hot_place`, { key: searchStr }, 'post')
}

// 获取行程详情
export function getTripDetail (id, headers) {
  return fetch(`/travel_plans/${id}`, null, 'get', headers)
}

// 获取所有景点
export function getAllPois (id) {
  return fetch(`/sites/${id}/pois`)
}

// 删除行程中的景点
export function deletePlanSite (id, data, headers) {
  return fetch(`/travel_plans/${id}/remove_site`, data, 'post', headers)
}

// 行程添加景点
export function addTripSite (id, data, headers) {
  return fetch(`/travel_plans/${id}/add_site`, data, 'post', headers)
}

// 景点设置喂起点
export function setAsStart (id, data, headers) {
  return fetch(`/travel_plans/${id}/top`, data, 'post', headers)
}

// 行程优化
export function tripOptimize (id, headers) {
  return fetch(`/travel_plans/${id}/optimize`, null, 'get', headers)
}

// rws 获取行程详情
export function getRwsTripDetail (id, headers) {
  return fetch(`/travel_plans/${id}`, null, 'get', headers, '/v1')
}

export function getRwsGuideRouteTripDetail (id, headers) {
  return fetch(`/guide_routes/${id}`, null, 'get', headers, '/sg')
}

// rws修改行程
export function rwsEditTrip (id, data, headers) {
  return fetch(`/travel_plans/${id}`, data, 'put', headers, '/v1')
}

// rws 调整顺序
export function rwsChangeOrder(id, data, headers) {
  return fetch(`/travel_plans/${id}/sort`, data, 'get', headers, '/v1')
}

// 获取bus信息
export function getBus (id, params) {
  return fetch(`/site_stations/${id}`, params, 'get')
}

// mall_miniapp 获取商场列表
//景区列表
export function getShopList(data) {
  return fetch('/sites', data, 'get', null, '/v1')
}

// 获取导航历史
export function getNavHistories (headers,params) {
  return fetch('/nav_histories', params , 'get', headers)
}

// 删除导航历史
export function deleteNavHistory (headers) {
  return fetch('/nav_histories/batch_destroy', null, 'delete', headers)
}

export function getMapList (params, type) {
  let url = ''
  if (type === 'poi_promotion') {
      url = '/poi_promotions'
  }
  if (type === 'site') {
      url = '/sites'
  }
  if (type === 'hotel') {
      url = '/hotels'
  }
  if (type === 'merchant') {
      url = '/merchants'
  }
  if (type === 'show_item') {
      url = '/show_items'
  }
  if (type === 'site_shop') {
      url = '/site_shops'
  }
  if (type === 'site_activity') {
      url = '/site_activities'
  }
  return fetch(url, params, 'get')
}

export function getScenicDetail (id, data) {
  return fetch(`/sites/${id}`, data, 'get')
}

export function getEventDetail (id, data) {
  return fetch( `/site_activities/${id}`, data, 'get')
}

export function getHotelDetail (id, data) {
  return fetch(`/hotels/${id}`, data, 'get')
}

export function getMallDetail (id, data) {
  return fetch(`/site_shops/${id}`, data, 'get')
}

export function getMerchantDetail (id, data) {
  return fetch(`/merchants/${id}`, data, 'get')
}

export function getShowDetail (id, data) {
  return fetch(`/show_items/${id}`, data, 'get')
}

export function getPromotionDetail (id, data) {
  return fetch(`/poi_promotions/${id}`, data, 'get')
}
//获取pio 详情数据
export function getPoiDetail (data) {
  return fetch(`/sites/poi_detail`, data, 'get')
}
